import { gql } from "@apollo/client";

export const GET_COMPANY = gql`
  query ($id: ID!) {
    getCompany(id: $id) {
      id
      name
      internalReference
      accountingFirm {
        id
        name
      }
      settings {
        serviceTypes {
          label
          value
        }
      }
    }
  }
`;

export const GET_ACCOUNTING_FIRM = gql`
  query ($accountingFirmId: ID!) {
    getAccountingFirm(id: $accountingFirmId) {
      id
      name
      companies {
        id
        name
        internalReference
      }
    }
  }
`;
